import React, { Component } from 'react'
import { Table, Button, Tooltip ,Select, Form,  Spin,Divider} from 'antd'
import API from '../../../services/API'
const { Option } = Select



class CustomersSearchContainer extends Component {

    state = {
        currentCustomer:'',
        customers: {
			data: [],
			loading: false,
        },

	}

    handleCustomerSearch = (value)=>{
        this.getResourceTypeahead(
			'customers',
			`/api/customers?filter[q]=${value}`,
			(customers) => ({
				text: `${customers.rfc ? customers.rfc+'|':''}  ${customers.social_reason} (${customers.email})`,
				value: customers.id,
			}),
		)
    }

    handleCustomerChange = (value)=>{
        this.props.history.push(`/customers/edit/${value.key}`)
    }

    getResourceTypeahead = async (resource, uri, stateCallback) => {
		try {
			await this.setState({
				[resource]: {
					...this.state[resource],
					loading: true,
				},
			})
            const response = await API.get(uri)
			this.setState({
				[resource]: {
					data: response.data.data.map(stateCallback),
					loading: false,
				},
			})
		} catch (error) {
			this.setState({
				[resource]: {
					data: [],
					loading: false,
				},
            })
		}
    }

    render() {
        return (
          <React.Fragment>

                <Divider> Busqueda de clientes</Divider>

           <div className="ant-header-button">
                <Tooltip title="Crear clientes" placement="left">
                    <Button type="primary" shape="circle" icon="plus" onClick={() => this.props.history.push('/customers/create')} />
                </Tooltip>
             </div>

             <Form className="ant-item-center">
             <Form.Item label="Cliente">
                <Select
                    showSearch
                    labelInValue
                    value={this.state.currentCustomer || undefined}
                    placeholder={"Busca un cliente..."}
                     notFoundContent={
                        this.state.customers.loading ? (
                            <Spin size="small" />
                        ) : (
                            'No hay resultados'
                        )
                    }
                    filterOption={false}
                    onSearch={this.handleCustomerSearch}
                    onChange={this.handleCustomerChange}
                    style={{ width: '100%' }}
                >
                    {this.state.customers.data.map(
                        (d) => {
                            return (
                                <Option key={d.value}>
                                    {d.text}
                                </Option>
                            )
                        },
                    )}
                </Select>
                </Form.Item>

             </Form>




          </React.Fragment>
        )
      }
}

export default CustomersSearchContainer

